import { motion } from 'framer-motion';
import { staggerContainer, staggerItem } from '../../lib/motion';

/**
 * Substitui o cálculo manual de `animationDelay: ${200 + index * 150}ms`
 * que cada lista de cards/passos/opções repetia do zero. O framer-motion
 * propaga o stagger para os filhos sozinho — cada StaggerItem só herda
 * a variant do pai.
 *
 * mode="scroll" (padrão, landing page) usa whileInView. mode="mount"
 * (wizard/formulário) anima direto ao montar — ver o comentário em
 * Reveal.js sobre por que whileInView travava a primeira pergunta do
 * wizard em opacity:0.
 *
 * Uso:
 *   <StaggerGroup>
 *     {items.map(item => <StaggerItem key={item.id}>...</StaggerItem>)}
 *   </StaggerGroup>
 */
export const StaggerGroup = ({ children, staggerDelay = 0.1, startDelay = 0, className = '', mode = 'scroll', once = true, amount = 0.15, as = 'div', ...rest }) => {
    const Tag = motion[as] || motion.div;
    const modeProps = mode === 'mount'
        ? { initial: 'hidden', animate: 'visible' }
        : { initial: 'hidden', whileInView: 'visible', viewport: { once, amount } };

    return (
        <Tag
            className={className}
            variants={staggerContainer(staggerDelay, startDelay)}
            {...modeProps}
            {...rest}
        >
            {children}
        </Tag>
    );
};

export const StaggerItem = ({ children, className = '', as = 'div', ...rest }) => {
    const Tag = motion[as] || motion.div;
    return (
        <Tag className={className} variants={staggerItem} {...rest}>
            {children}
        </Tag>
    );
};
